import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import dayjs from 'dayjs';
import dates from '@/libs/d.dates';
import express from '@/const/express';
import { mapState } from 'vuex';
export default {
  meta: {
    title: '服务单详情',
    auth: true,
    authorityValue: "store-refund-manage"
  },
  name: 'returnGoods',
  data: function data() {
    return {
      tabData: {},
      layer: {
        show: false,
        title: '同意申请',
        showButton: true,
        form: {}
      },
      options: [],
      query: {},
      applyTime: ''
    };
  },
  filters: {
    addressDetails: function addressDetails(e) {
      try {
        var str = ['contactName', 'phoneNumber', 'province', 'city', 'district', 'details'].map(function (v) {
          return e[v];
        }).join(',');
        return str;
      } catch (err) {}
    },
    expressCompany: function expressCompany(code) {
      var name = '';
      express.forEach(function (e) {
        if (e.code === code) {
          name = e.company;
        }
      });
      return name;
    },
    invoiceType: function invoiceType(val) {
      if (val === 1) return '普通发票';
      if (val === 2) return '增值税专用发票';
      if (val === 3) return '不开发票';
    }
  },
  computed: _objectSpread({}, mapState('d2admin', {
    menu: function menu(state) {
      return state.permission.routeKey;
    }
  })),
  methods: {
    isShow: function isShow(auto) {
      return this.isBtnGroud(this.menu, auto);
    },
    refundStatusComp: function refundStatusComp(i) {
      var refundStatus = this.tabData.refundStatus == i;
      return refundStatus;
    },
    date2Time: function date2Time() {
      var _this = this;

      if (!this.refundStatusComp(1) || !this.refundStatusComp(2)) return;
      var addTime = (this.refundStatusComp(1) ? 2 : 15) * 24;
      var inTime = setInterval(function () {
        var e = _this.tabData.applyTime;
        if (!e) return '';
        var a = dayjs(e).add(addTime, 'hour').valueOf();
        var b = dayjs();
        var t = a - b;

        if (t >= 0) {
          var _dates$countDownObj = dates.countDownObj(t),
              d = _dates$countDownObj.d,
              h = _dates$countDownObj.h,
              m = _dates$countDownObj.m,
              s = _dates$countDownObj.s;

          _this.applyTime = '剩余' + d + ' 天 ' + h + ' 小时 ' + m + ' 分钟 ' + s + ' 秒 ';
        } else {
          clearInterval(inTime);

          _this.dataBind(_this.query);
        }
      }, 1000);
      this.$once('hook:beforeDestroy', function () {
        clearInterval(inTime);
      });
    },
    getReturnList: function getReturnList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this2$$api$ad, records;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$api.addressList({
                  pageSize: 1000 * 1000,
                  addressType: 1
                });

              case 2:
                _yield$_this2$$api$ad = _context.sent;
                records = _yield$_this2$$api$ad.records;
                _this2.options = records;
                console.log('111111', _this2.options);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    confirm: function confirm() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.layer.form.auditDescription == '')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", _this3.$message.error("请输入审核意见"));

              case 2:
                _context2.next = 4;
                return _this3.$api.auditRefund(_this3.layer.form);

              case 4:
                _this3.$notify.success('成功');

                _context2.next = 7;
                return _this3.dataBind(_this3.query);

              case 7:
                _this3.layer.show = false;
                _context2.next = 10;
                return _this3.getRefundConsults(_this3.query);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    successClick: function successClick(refundStatus) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  refundStatus: refundStatus,
                  auditDescription: ''
                };
                _this4.layer.title = refundStatus == 2 ? '同意申请' : '拒绝申请';
                _this4.layer.show = true;
                _this4.layer.form = _objectSpread(_objectSpread({}, params), _this4.query);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    errorClick: function errorClick(refundStatus) {
      var _this5 = this;

      var title = refundStatus == 2 ? '确认收货' : '拒绝收货';
      var msg = refundStatus == 2 ? '确定已收到货物了么?' : '';
      var Pla = refundStatus == 2 ? '请输入收货备注' : '请输入拒绝收货的原因';
      this.$prompt(msg, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: Pla,
        inputType: 'textarea',
        inputPlaceholder: Pla
      }).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref) {
          var value, params;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  value = _ref.value;
                  params = {
                    checkedStatus: refundStatus,
                    checkedDescription: value,
                    refundId: _this5.tabData.refundId
                  };
                  _context5.next = 4;
                  return _this5.$api.checked(params);

                case 4:
                  YL.message('操作成功');
                  setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return _this5.dataBind(_this5.query);

                          case 2:
                            _context4.next = 4;
                            return _this5.getRefundConsults(_this5.query);

                          case 4:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  })), 1000);

                case 6:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    dataBind: function dataBind(item) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this6.$api.refundDetails(item);

              case 2:
                data = _context6.sent;
                _this6.tabData = data;

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    getRefundConsults: function getRefundConsults(item) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$_this7$$api$re, records;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this7.$api.refundConsults(_objectSpread({}, _this7.query));

              case 2:
                _yield$_this7$$api$re = _context7.sent;
                records = _yield$_this7$$api$re.records;

                _this7.$set(_this7.tabData, 'refundConsults', records);

                console.log('22222', _this7.tabData);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    location: function location(data) {
      if (!data) return '';else return data.province + data.city + data.district + data.details;
    },
    returnLoction: function returnLoction(data) {
      if (!data) return '';else return data.consigneeProvince + data.consigneeCity + data.consigneeDistrict + data.consigneeDetails;
    },
    refundAddress: function refundAddress(data) {
      if (!data) return '';else return data.contactName + ' ' + data.phoneNumber + ' ' + data.province + data.city + data.district + data.details;
    },
    handleGoRoute: function handleGoRoute(id) {
      if (this.isShow('store-order-management')) {
        this.goRoute('orderDetail', {
          orderId: id
        });
      } else {
        this.$message.error('您没有权限访问');
      }
    }
  },
  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      var query;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              query = _this8.$route.query;
              _this8.query = query;
              _context8.next = 4;
              return _this8.dataBind(query);

            case 4:
              _this8.date2Time();

              _context8.next = 7;
              return _this8.getRefundConsults(query);

            case 7:
              _context8.next = 9;
              return _this8.getReturnList();

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }))();
  }
};